import { Link } from "react-router-dom";
import { useCommunes } from "../lib/useCommunes";

export default function PestCityIndex() {
  const communes = useCommunes();
  const chip = "inline-block border text-sm px-4 py-2 rounded-full transition-colors";
  return (
    <section id="communes" data-testid="pest-city-index" className="py-16 md:py-20 bg-[#F8FBF8]">
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <h2 className="font-['Outfit'] text-3xl sm:text-4xl font-light text-[#1A2E1C] tracking-tight mb-3">
          Anti-nuisibles <span className="font-medium text-[#1B5E20]">par commune</span>
        </h2>
        <p className="text-[#5C705E] mb-8">Frelons, rongeurs, chenilles, punaises de lit : trouvez votre commune. Toute la Creuse est desservie.</p>
        <div className="flex flex-wrap justify-center gap-2">
          {communes.map((c) =>
            c.href ? (
              <Link
                key={c.key}
                to={c.href}
                data-testid={`pest-city-index-${c.key}`}
                className={`${chip} bg-white border-[#E5EBE5] text-[#1B5E20] hover:bg-[#1B5E20] hover:text-white`}
              >
                {c.name}
              </Link>
            ) : (
              <a
                key={c.key}
                href="#carte"
                data-testid={`pest-city-index-${c.key}`}
                className={`${chip} bg-[#F1F8F2] border-dashed border-[#A5D6A7] text-[#1A2E1C] hover:border-[#1B5E20]`}
              >
                {c.name}
              </a>
            ),
          )}
        </div>
      </div>
    </section>
  );
}
